import React from 'react';
import { BsCartCheckFill } from "react-icons/bs";
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

const BtnIsCar = () => {
    const renderTooltip = (props) => (
        <Tooltip id="tooltip-car" {...props}>
            Este produto já está no seu carrinho!
        </Tooltip>
    );

    return (
        <OverlayTrigger
            placement="top" // Posição do tooltip
            delay={{ show: 250, hide: 400 }} // Atrasos na exibição e ocultação
            overlay={renderTooltip}
        >
            <div className='bg-success icon-iscar d-flex justify-content-center align-items-center'>
                <BsCartCheckFill size={24} color="#fff" />
            </div>
        </OverlayTrigger>
    );
}

export default BtnIsCar;
